"use client";

import { motion } from "framer-motion";
import { memo } from "react";
import type { UseChatHelpers } from "@ai-sdk/react";
import type { ChatMessage } from "@tracify/shared";

interface SuggestedActionsProps {
  sendMessage: UseChatHelpers<ChatMessage>["sendMessage"];
  runtimeContextTextPart: {
    type: "text";
    text: string;
  };
}

function PureSuggestedActions({
  sendMessage,
  runtimeContextTextPart,
}: SuggestedActionsProps) {
  const suggestedActions = [
    {
      title: "Compare performance",
      label: "of my last two campaigns",
      action: "Compare the performance of my last two campaigns",
    },
    {
      title: "What is my best",
      label: "performing ad creative?",
      action: "What is my best performing ad creative?",
    },
    {
      title: "Which channel has",
      label: "the highest ROAS?",
      action: "Which channel has the highest ROAS?",
    },
    {
      title: "Show customer journey for",
      label: "recent conversions",
      action: "Show me the customer journey for recent conversions",
    },
  ];

  return (
    <div
      data-testid="suggested-actions"
      className="grid grid-cols-1 sm:grid-cols-2 gap-2 w-full min-w-0"
    >
      {suggestedActions.map((suggestedAction, index) => (
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 20 }}
          transition={{ delay: 0.05 * index }}
          key={`suggested-action-${suggestedAction.title}-${index}`}
          className={index > 1 ? "hidden sm:block min-w-0" : "block min-w-0"}
        >
          <button
            type="button"
            onClick={async () => {
              sendMessage({
                role: "user",
                parts: [
                  { type: "text", text: suggestedAction.action },
                  runtimeContextTextPart,
                ],
              });
            }}
            className="text-left border rounded-xl p-2 text-sm flex-1 w-full h-full min-w-0 whitespace-normal break-words justify-start items-start transition-colors hover:bg-muted"
          >
            <span className="font-medium">{suggestedAction.title}</span>{" "}
            <span className="text-muted-foreground">
              {suggestedAction.label}
            </span>
          </button>
        </motion.div>
      ))}
    </div>
  );
}

export const SuggestedActions = memo(PureSuggestedActions);
